import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { injectIntl, intlShape } from 'react-intl';
import { connect } from 'react-redux';
import { FriendbuyWidget } from 'components/Friendbuy/FriendbuyWidget';
import { decorateWith } from 'helpers/decorator';
import { isEmpty } from 'helpers/verify';
import { deepExtract } from 'helpers/deep';
import { userProfile } from 'redux/saga/entities/bound';

export const mapStateToProps = state => {
  const { friendbuy_info: rafInfo, id, email, msa } = userProfile.data(state) ?? {};

  return {
    email,
    loaded: !isEmpty(rafInfo),
    userId: id,
    countryCode: deepExtract('country_code', msa, 'USA'),
    widgetCode: rafInfo && rafInfo.widget_code,
  };
};

export class ShowFriendbuyWidgetUnwrapped extends PureComponent {
  state = { open: false };

  handleClick = e => {
    e.stopPropagation();
    const { onClick } = this.props;
    this.setState({ open: true });

    if (onClick) {
      onClick();
    }
  };

  handleFriendbuyWidgetClose = () => this.setState({ open: false });

  render() {
    const { children, className, email, intl, loaded, userId, countryCode, widgetCode } = this.props;

    return (
      loaded && (
        <>
          <a className={className} onClick={this.handleClick}>
            {children}
          </a>
          {this.state.open && (
            <FriendbuyWidget
              countryCode={countryCode}
              userId={userId}
              email={email}
              intl={intl}
              widgetCode={widgetCode}
              onClose={this.handleFriendbuyWidgetClose}
            />
          )}
        </>
      )
    );
  }
}

ShowFriendbuyWidgetUnwrapped.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  email: PropTypes.string,
  intl: intlShape,
  loaded: PropTypes.bool.isRequired,
  onClick: PropTypes.func,
  userId: PropTypes.number,
  countryCode: PropTypes.string,
  widgetCode: PropTypes.string,
};

export const ShowFriendbuyWidget = decorateWith(connect(mapStateToProps), injectIntl)(ShowFriendbuyWidgetUnwrapped);
